import React, { useEffect, useState } from 'react'
import RegistrationComponent from '../Components/RegistrationComponent'
import { useNavigate, useParams } from 'react-router-dom';
import { validateInviteCode } from '../../Admin/Services/AdminService';
import { Alert, AlertProps } from '../../Shared/Utils/Alert';
import { validateEarlyAccessUser } from '../../LandingScreens/Service/EarlyAccessService';
import { UserEarlyAccessResponse } from '../../LandingScreens/Types/EarlyAccessType';
import EarlyAccessRegistrationComponent from '../Components/EarlyAccessRegistrationComponent';

function EarlyAccessRegistrationPage() {

   const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [alert, setAlert] = useState<AlertProps | null>(null);
  const [adminData, setAdminData] = useState<UserEarlyAccessResponse | null>(null);
  
  

  useEffect(() => {
    const checkInvite = async () => {
      if (!userId) {
        setAlert({
          variant: "error",
          title: "Registration Error",
          message: "Invalid or missing invitation code. Please contact support for assistance.", 
          autoCloseMs:5000,
           onClose: () => setAlert(null),
        });
        return;
      }

      try {
        const response = await validateEarlyAccessUser(userId);
        setAdminData(response.data);
      
        if (!response.success) {
          setStatus('error');
          setAlert({
          variant: "error",
          title: "Registration Error",
          message: response.message, 
          autoCloseMs:5000,
           onClose: () => setAlert(null),
        });
          // Redirect to registration/login after a brief delay to show success
          setTimeout(() => navigate('/login'), 2000);
        }else {
          setStatus('success');
        }
      } catch (err) {
        setStatus('error');
      }
    };

    checkInvite();
  }, [userId, navigate]);


return (
  <div>


    {alert && (
      <div className="mb-6">
        <Alert {...alert} onClose={() => setAlert(null)} />
      </div>
    )}

    {status === 'loading' && (
      <div>Validating...</div>
    )}

    {status === 'success' && (
      <EarlyAccessRegistrationComponent data={adminData!}/>
    )}

{/* {status === 'success' && adminData && (
  <EarlyAccessRegistrationComponent data={adminData} />
)} */}

  </div>
);
}

export default EarlyAccessRegistrationPage